import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    vehicleInfo: '',
    vehicleModel: '',
    vale: false,
    km: '',
    maintenance: false,
    appointmentRequests: [],
    dealer: '',
    slot: '',
    timeSlot: '',
    phone: '',
    name: '',
    surname: '',
    email: '',
    kvkkPermission: false,
    permission: false,
    phonePermission: false,
    smsPermission: false,
    emailPermission: false,
};

const formSlice = createSlice({
    name: 'form',
    initialState,
    reducers: {
        setForm: (state, action) => {
            return action.payload;
        },
        removeForm: () => {
            return initialState;
        },
        setTimeSlot: (state, action) => {
            state.timeSlot = action.payload;
        },
        setSlot: (state, action) => {
            state.slot = action.payload;
        },
        setDealer: (state, action) => {
            state.dealer = action.payload;
        },
        setVale: (state, action) => {
            const { vale } = action.payload;
            state.vale = vale;
        },
        setVehicleInfo: (state, action) => {
            state.vehicleInfo = action.payload;
        },
        setVehicleModel: (state, action) => {
            state.vehicleModel = action.payload;
        },
        setCustomerInfo: (state, action) => {
            const { phone, name, surname, email, kvkkPermission, permission, phonePermission, smsPermission, emailPermission } = action.payload;
            state.phone = phone;
            state.name = name;
            state.surname = surname;
            state.email = email;
            state.kvkkPermission = kvkkPermission;
            state.permission = permission;
            state.phonePermission = phonePermission;
            state.smsPermission = smsPermission;
            state.emailPermission = emailPermission;
        },
        setAppointmentInfo: (state, action) => {
            const { vale, km, maintenance, appointmentRequests } = action.payload;
            state.vale = vale;
            state.km = km;
            state.maintenance = maintenance;
            state.appointmentRequests = appointmentRequests;
        },
        setDealerInfo: (state, action) => {
            state.dealer = action.payload.dealer;
        },
        setTimeInfo: (state, action) => {
            state.slot = action.payload.slot;
            state.timeSlot = action.payload.timeSlot;
        },
        removeTimeInfo: (state) => {
            state.slot = '';
            state.timeSlot = '';
        },
        updateForm: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        },
    },
});

export const { setForm, removeForm, setTimeSlot, setSlot, setDealer, setVale, setVehicleInfo, setVehicleModel, setCustomerInfo, setAppointmentInfo, setDealerInfo, setTimeInfo, removeTimeInfo, updateForm, } = formSlice.actions;
export default formSlice.reducer;